(function () {
  const KEY = 'theme-mode';
  const modes = ['system', 'light', 'dark'];

  function getStored() {
    try {
      return localStorage.getItem(KEY) || 'system';
    } catch {
      return 'system';
    }
  }

  function setStored(mode) {
    try {
      localStorage.setItem(KEY, mode);
    } catch (_) {}
  }

  function isDark(mode) {
    if (mode === 'dark') return true;
    if (mode === 'light') return false;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }

  function apply(mode) {
    document.documentElement.classList.remove('theme-mode-system', 'theme-mode-light', 'theme-mode-dark');
    document.documentElement.classList.add('theme-mode-' + mode);
    document.documentElement.style.colorScheme = isDark(mode) ? 'dark' : 'light';
  }

  function getOptionLabel(container, mode) {
    var option = container.querySelector('.theme-mode-option[data-mode="' + mode + '"]');
    if (!option) return mode;
    var textSpan = option.querySelector('span:not(.theme-mode-check)');
    return textSpan ? textSpan.textContent.trim() : mode;
  }

  function updateUI(container, mode) {
    if (!container) return;
    var labelEl = container.querySelector('.theme-mode-disclosure__label');
    if (labelEl) labelEl.textContent = getOptionLabel(container, mode);
    container.querySelectorAll('.theme-mode-option').forEach(function (btn) {
      var check = btn.querySelector('.theme-mode-check');
      var isActive = btn.dataset.mode === mode;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (check) check.classList.toggle('visibility-hidden', !isActive);
    });
  }

  function closePanel(container) {
    if (!container) return;
    var trigger = container.querySelector('.theme-mode-disclosure__trigger');
    var panel = container.querySelector('.theme-mode-disclosure__panel');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('hidden', true);
  }

  function openPanel(container) {
    if (!container) return;
    var trigger = container.querySelector('.theme-mode-disclosure__trigger');
    var panel = container.querySelector('.theme-mode-disclosure__panel');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.removeAttribute('hidden');
  }

  function init() {
    var container = document.querySelector('[data-theme-mode]');
    if (!container) return;

    var trigger = container.querySelector('.theme-mode-disclosure__trigger');
    var panel = container.querySelector('.theme-mode-disclosure__panel');
    var current = getStored();

    apply(current);
    updateUI(container, current);

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = panel.getAttribute('hidden') === null;
      if (isOpen) {
        closePanel(container);
      } else {
        openPanel(container);
      }
    });

    container.querySelectorAll('.theme-mode-option').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var mode = btn.dataset.mode;
        if (!mode || modes.indexOf(mode) === -1) return;
        setStored(mode);
        apply(mode);
        updateUI(container, mode);
        closePanel(container);
      });
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) closePanel(container);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
      if (getStored() === 'system') apply('system');
    });
  }
})();
